import {useEffect, useState} from "react";
import axios from "axios";

const GeoLocation = ({lat = '', lng = ''}) => {

    const [address, setAddress] = useState('')

    useEffect(() => {
        if (lat && lng) {
            (async () => {
                try {
                    const response = await axios.get(
                        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}
                        &location_type=ROOFTOP&result_type=street_address&key=AIzaSyCyqGWfLjwQjvkmSoyS98ptW3fIrG_Ytio`
                    );
                    if (response?.data?.status === 'OK') {
                        setAddress(response.data.results[0].formatted_address);
                    } else {
                        // setAddress('Null')
                        setAddress((response?.data?.plus_code?.compound_code).split(' ').slice(1).join(' '));
                    }
                } catch (e) {
                    setAddress('Null');
                    console.log(e)
                }

                }
            )();
        }


    }, [lat, lng]);

    return (
        <div>{address}</div>
    )
}

export default GeoLocation;
